import { create } from 'zustand';
import { toggleOffCanvas } from 'utils';

const useOffcanvasStore = create((set) => ({
  formType: null,
  formProps: {},
  isOpen: false,
  openOffcanvas: (type, props = {}) => set({ formType: type, formProps: props, isOpen: true }),
  closeOffcanvas: () => {
    // Remove backdrop and reset body styles
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('modal-open');
    
    set({ formType: null, formProps: {}, isOpen: false });
  },
}));

export default useOffcanvasStore; 